import {
  layoutRooms,
  determineRoomBounds,
  makeCircleTransformer,
  arrangeNewNode,
} from "./layout.js";

import {clamp} from '../utility.js';

// the types of space layoutRooms is designed to account for
const SPACE_TYPES = ['hub', 'lounge', 'create_space', 'hybrid', 'digital'];
const ROOM_SIZES = {
  hub: 35,
  lounge: 35,
  create_space: 12,
  digital: 17,
  hybrid: 30,
  livestream: 35
};
// workingData is cached so it can be used to calculate new room angles
let workingData = [];

export function calcNewRoomDistributionAngle(){
  let newSegAngle = arrangeNewNode(workingData);
  // not entirely sure about the Math.abs here?
  return Math.round(Math.abs(newSegAngle.baseAngle));
}

export function getRoomPositions(roomData, isMobile) {
  // it's a surprise tool that will help us later
  let rooms = document.querySelector('.rooms-container');

  // return if called while not on the lobby page, the room container doesn't exist or its size is zero
  if(!rooms || rooms?.offsetWidth === 0) {
    return roomData;
  }

  // clone the data to ensure the original data stays unmodified
  let rtn = roomData.map(r => ({...r}) );

  // process the data into something the layout functions can use
  workingData = rtn.map(r => {
    // the reason why fallback layout is hybrid and fallback radius is 35 is because
    // that's what's supposed to be used for spaceType "open", which is technically unsupported
    // but afaik it's the only unsupported type left kicking around post-strangulation
    let st = r.spaceType;
    if(!SPACE_TYPES.includes(st)) {
      console.warn(`Unknown space type "${st}" on room "${r.name}", falling back to hybrid layout`);
      st = 'hybrid';
    }

    let size = r.conferenceType === 'livestream' ? ROOM_SIZES[r.conferenceType] : ROOM_SIZES[st];

    if(isMobile) size = clamp(size, 12, 25);

    return {
      topic: r.name,
      x: 0, y: 0,
      layoutType: st,
      baseAngle: r.baseAngle,
      radius: size + (5 * Math.sqrt(r.online)),
    }
  });

  // do the layout magic
  // padding sets the distance between circles
  // the last arg is an offset in degrees for digital (temporary) rooms
  layoutRooms(workingData, {padding: 5}, 40);

  // as you might have noticed, the numbers for the radius/padding of the circles are only relative to eachother
  // the below creates a function that gives those numbers meaning, by scaling them to the available viewport (rooms-container)
  // it does this by getting the bounding box of the circles, and scaling that to the bounding box of the viewport
  // then we apply that scaling to the circles
  const scaleToView = makeCircleTransformer(
    determineRoomBounds(workingData),
    {
      minX: 0, minY: 0,
      maxX: rooms.offsetWidth,
      maxY: rooms.offsetHeight,
    },
    true
  );

  workingData.forEach(({x, y, radius}, i) => {
    rtn[i].position = scaleToView({ x, y, r: radius });
  });

  return rtn;
}